module.exports = __webpack_public_path__ + "img/maison1.0e773695.jpg";